import React, { useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';
import { getContentByCategory } from '../services/api';

export default function CaseStories() {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    getContentByCategory('CASE_STORY')
      .then((res) => setStories(res.data))
      .catch(() => setStories([]));
  }, []);

  return (
    <div>
      <PageHeader
        eyebrow="Real Case Stories"
        title="Lessons From Real Workplace Matters"
        subtitle="Educational case studies for public awareness — names and identifying details are always protected."
      />
      <section className="section">
        <div className="container">
          {stories.length === 0 ? (
            <div className="card"><p>Case stories will be published here as they become available.</p></div>
          ) : (
            <div className="grid grid-2">
              {stories.map((s) => (
                <div className="card" key={s.id}>
                  <h3>{s.title}</h3>
                  <p>{s.content}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
